import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "设备分析",
  "use": "设备分析-usage",
  "viewBox": "0 0 20.49 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20.49 20\" id=\"设备分析\"><defs><style>#设备分析 .cls-1{fill:#4238c9;}#设备分析 .cls-2{fill:#867fee;}</style></defs><g id=\"设备分析_页面-1\"><g id=\"设备分析_配置中心-安全设备管理\"><g id=\"设备分析_分析统计\"><path id=\"设备分析_路径\" class=\"cls-1\" d=\"M9.68,11.27V.65A9.68,9.68,0,1,0,19,12.77a11.33,11.33,0,0,0,.23-1.5Z\" /><path id=\"设备分析_路径-2\" data-name=\"路径\" class=\"cls-2\" d=\"M11.13,9.8h9.36v0A9.78,9.78,0,0,0,11.13,0Z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol